var x = /* @__PURE__ */ ((r) => (r.Text = "text", r.Currency = "currency", r.All = "all", r))(x || {});
export {
  x as SelectedCategoriesEnum
};
